// extracted by mini-css-extract-plugin
export default {"favouriteContainer":"FavouriteToggle_favouriteContainer__2WPYC"};